import { useEffect } from 'react';

const SITE_ORIGIN = 'https://docmania.co';

/**
 * Sets indexable SEO tags for public tool landing pages (SPA).
 */
export default function ToolSeoHead({ title, description, canonicalPath }) {
  useEffect(() => {
    const prevTitle = document.title;
    document.title = title;

    const ensureMeta = (name) => {
      let el = document.querySelector(`meta[name="${name}"]`);
      if (!el) {
        el = document.createElement('meta');
        el.setAttribute('name', name);
        document.head.appendChild(el);
      }
      return el;
    };

    const metaDesc = ensureMeta('description');
    const prevDesc = metaDesc.getAttribute('content');
    metaDesc.setAttribute('content', description);

    const robots = ensureMeta('robots');
    const prevRobots = robots.getAttribute('content');
    robots.setAttribute('content', 'index, follow');

    let canonical = document.querySelector('link[rel="canonical"]');
    const createdCanonical = !canonical;
    if (!canonical) {
      canonical = document.createElement('link');
      canonical.setAttribute('rel', 'canonical');
      document.head.appendChild(canonical);
    }
    const prevCanonical = canonical.getAttribute('href');
    const href = canonicalPath.startsWith('http')
      ? canonicalPath
      : `${SITE_ORIGIN}${canonicalPath}`;
    canonical.setAttribute('href', href);

    return () => {
      document.title = prevTitle;
      if (prevDesc != null) metaDesc.setAttribute('content', prevDesc);
      if (prevRobots != null) robots.setAttribute('content', prevRobots);
      if (createdCanonical && canonical.parentNode) {
        canonical.parentNode.removeChild(canonical);
      } else if (prevCanonical != null) {
        canonical.setAttribute('href', prevCanonical);
      }
    };
  }, [title, description, canonicalPath]);

  return null;
}
